import NotificationActions from '../../actions/NotificationActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../constants/PosConstants';

import DOB from '../form/DOB.react';

class CancelCart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            backDate : ''
        };

        this.submitBackDate = this.submitBackDate.bind(this);
    }

    submitBackDate() {
        var self = this;

        if (this.state.backDate.length < 1 || !moment(this.state.backDate).isValid()) {
            NotificationActions.addNotification({ type : 'alert' , body : 'Add a valid date' });
            return;
        }

        AjaxPromises.POST(PosEndPoints.UPDATE_TRANSACTION_DATE, UserStore.getApiData({
            ShipmentId   : this.props.guest.ShipmentId,
            ActualDate     : moment(this.state.backDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss'), //Just do this at noon to get the date right
        })).then(res => {
            NotificationActions.addNotification({ type : 'success' , body : 'Date updated Successfully' });
            PopupActions.close();
        });
    }

    render() {
        var self = this;
        var guest = this.props.guest;

        return (
            <div className='popup popup__transparent'>
                <div
                    className='popup__content back-date'>

                    <div className='popup-header'>
                        BACK DATE

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <DOB
                        AllowInFuture
                        value={this.state.backDate}
                        onChange={(field, value) => { this.setState({ backDate : value }); }}
                        className='back-date__input' />

                    { !guest.IsPaid &&
                        <div
                            className='btn-green back-date__ok'
                            onClick={this.submitBackDate}
                            style={{'width' : '110px', 'margin' : '10px 0 0 10px'}}>

                            OK
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default CancelCart;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/BackDate.react.jsx